import "./voiceUser";
import {createApp} from 'vue';
import App from "./detail/App.vue";
import {ClientJS} from "clientjs";

createApp(App).mount('#js-app');

document.addEventListener('DOMContentLoaded', () => {

  //指定された id を id 属性として持つ DOM を渡すと true を返す関数を返す関数
  const _hasId = id => element => element instanceof HTMLElement && element.id === id;

  //指定された className を class 属性として持つ DOM を渡すと true を返す関数を返す関数
  const _hasClass = className => element => element instanceof HTMLElement && element.classList.contains(className);

  //何か来ても HTMLElement なら true を返す
  const _hasAny = () => () => element => element instanceof HTMLElement;

  //callback が true を返す要素を祖先までさかのぼって検索、存在すれば返し、なければ null を返す
  const _findParent = (callback, child) => {
    //null が来たら null を返す
    if (child === null) {
      return null;
    }

    //自身がクラスを持っていたら返す
    if (callback(child)) {
      return child;
    }

    //自身が html 要素なら null　を返す
    if (child instanceof HTMLHtmlElement) {
      return null;
    }

    //そうでなければ親を検索
    return _findParent(callback, child.parentElement);
  };

  //クラス名と発火させたい関数を結びつける
  const _attacheListener = (target, judge, callback) => {
    //対象のクラスが自陣 ~ 祖先に存在するか判定
    const currentTarget = _findParent(judge, target);

    //存在しなければ何もしない
    if ( ! currentTarget) {
      return;
    }

    //関数を発火させる
    callback(currentTarget);
  };

  //POST 通信用のヘッダーを得る
  const _getPostHeader = () => {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    };
  };

  // 共感ボタンの初期化
  const _empathyInit = async() => {
    try {
      const response = await fetch(document.querySelector('meta[name="site-url"]').content+'voice/get-empathy?fingerprint='+(new ClientJS().getFingerprint()));

      // エラーがあったら何もしない
      if ( ! response.ok) {
        throw new Error('エラーが発生しました。');
      }

      // レスポンスを取得
      const ids = await response.json();

      // 配列でなければ何もしない
      if ( ! Array.isArray(ids)) {
        throw new Error('エラーが発生しました。');
      }

      // ボタンを取得
      const buttons = document.querySelectorAll('.js-empathy');

      // ボタンがなければ何もしない
      if ( ! buttons) {
        return;
      }

      // ボタンを一つずつ処理
      for (const button of buttons) {
        // ボタンの id が ids に含まれていれば checked にする
        if (ids.some(id => Number(id) === Number(button.value))) {
          button.checked = true;
        }
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  /**
   * テーブル・ページャー最新情報に再描画する
   * @returns {Promise<void>}
   * @private
   */
  const _replaceData = async () => {
    //対象となる領域を得る
    const replaceTarget = document.getElementById('replace');

    //書き換え対象が無ければ何もしない
    if ( ! replaceTarget) {
      return;
    }

    //サーバーに書き換え HTML を依頼
    try {
      //現在の URL を Ajax 経由で再アクセス
      const res = await fetch(window.location.href);
      const body = await res.text();

      //フォームの中身のみ抜き出す
      replaceTarget.innerHTML = body
        .replace(/^[\s\S]*<!--replace:start-->/, '<!--replace:start-->')
        .replace(/<!--replace:end-->[\s\S]*$/, '<!--replace:end-->');

      // 共感ボタンの初期化
      _empathyInit();
    }

      //サーバーが応答しない
    catch (error) {
      alert("データの再描画に失敗しました。\n更新はされているので、ページをリロードしてください。");
    }
  };

  //ブール値を変更する関数
  const _handleChangeBoolean = async(target) => {
    // 必要情報が存在しなければ何もしない
    if (
      ! (target instanceof HTMLElement) ||
      ! ('endpoint' in target.dataset) ||
      ! ('value' in target.dataset)
    ) {
      return;
    }

    // 送信 POST パラメータを作成
    const formData = new FormData();
    formData.append('value', target.dataset.value);
    formData.append('fingerprint', (new ClientJS().getFingerprint()));

    //通信を試みる
    try {
      //サーバと通信
      const response = await fetch(target.dataset.endpoint, {method: 'post', headers: _getPostHeader(), body: formData});

      //レスポンス異常発生
      if ( ! response.ok) {
        //もし 404 (未ログインユーザーが到達できないページ) or 419 (セッショントークン切れ) だったらログインしていない
        if (response.status === 404 || response.status === 419) {
          throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
        }

        //エラーメッセージが返っているか判定
        const parameter = await response.json();

        //もしエラーメッセージが存在すれば返す
        if ('errors' in parameter && Array.isArray(parameter.errors)) {
          throw parameter.errors;
        }
        if ('messages' in parameter && Array.isArray(parameter.messages)) {
          throw parameter.messages;
        }

        //もし単発エラーがあれば返す
        if ('message' in parameter && typeof parameter.message === 'string') {
          throw [parameter.message];
        }

        //エラーメッセージを文字列に変換して例外を投げる
        throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
      }

      //一覧・ページャーを切り替える
      _replaceData();
    }

      //エラーを alert で表示
    catch (error) {
      //恐らく通信途絶
      if (error instanceof TypeError) {
        alert('ネットワーク接続に失敗しました。');
      }

      //恐らく意図的な中断
      else if (error instanceof DOMException) {
        alert('ネットワーク接続が中断されました。');
      }

      //恐らくサーバーからのメッセージ
      else if (Array.isArray(error)) {
        alert(error.join("\n"));
      }

      //恐らくカスタムエラー
      else if (error instanceof Error) {
        alert(error.message);
      }

      //不明
      else {
        alert('エラーが発生しました。しばらくしてから再度お試しください。');
      }
    }
  };

  const _handleChangeEmpathy = async (target) => {
    // 必要情報が存在しなければ何もしない
    if ( ! (target instanceof HTMLInputElement)) {
      return;
    }

    // 送信 POST パラメータを作成
    const formData = new FormData();
    formData.append('fingerprint', (new ClientJS().getFingerprint()));

    //通信を試みる
    try {
      //サーバと通信
      const response = await fetch(document.querySelector('meta[name="site-url"]').content+'voice/'+(target.checked ? 'set' : 'delete')+'-empathy/'+target.value, {
        method: 'post',
        headers: _getPostHeader(),
        body: formData
      });

      //レスポンス異常発生
      if ( ! response.ok) {
        // ボタンのチェックを変更
        target.checked = ! target.checked;

        //もし 404 (未ログインユーザーが到達できないページ) or 419 (セッショントークン切れ) だったらログインしていない
        if (response.status === 404 || response.status === 419) {
          throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
        }

        //エラーメッセージが返っているか判定
        const parameter = await response.json();

        //もしエラーメッセージが存在すれば返す
        if ('errors' in parameter && Array.isArray(parameter.errors)) {
          throw parameter.errors;
        }
        if ('messages' in parameter && Array.isArray(parameter.messages)) {
          throw parameter.messages;
        }

        //もし単発エラーがあれば返す
        if ('message' in parameter && typeof parameter.message === 'string') {
          throw [parameter.message];
        }

        //エラーメッセージを文字列に変換して例外を投げる
        throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
      }

      // 応答 JSON のパース
      const parameter = await response.json();

      // 共感数を変更
      const count = document.querySelector('.js-empathyCount[data-id="'+target.value+'"]');
      if (count) {
        count.textContent = Number(parameter.count);
      }
    }

      //エラーを alert で表示
    catch (error) {
      //恐らく通信途絶
      if (error instanceof TypeError) {
        alert('ネットワーク接続に失敗しました。');
      }

      //恐らく意図的な中断
      else if (error instanceof DOMException) {
        alert('ネットワーク接続が中断されました。');
      }

      //恐らくサーバーからのメッセージ
      else if (Array.isArray(error)) {
        alert(error.join("\n"));
      }

      //恐らくカスタムエラー
      else if (error instanceof Error) {
        alert(error.message);
      }

      //不明
      else {
        alert('エラーが発生しました。しばらくしてから再度お試しください。');
      }
    }
  };

  //エントリーモーダルを開く
  const _handleOpenEntryModal = () => {
    window.dispatchEvent(new CustomEvent('openVoiceModal'));
  };

  //イベントハンドラ基底
  document.addEventListener('click', event => {
    _attacheListener(event.target, _hasClass('js-voice'), _handleOpenEntryModal);
  });
  document.addEventListener('change', event => {
    _attacheListener(event.target, _hasClass('js-empathy'), _handleChangeEmpathy);
    _attacheListener(event.target, _hasClass('js-favorite'), _handleChangeBoolean);
  });
  window.addEventListener('syncVoices', _replaceData);

  // 共感ボタンの初期化
  _empathyInit();
});
